export const LABEL_WIDTH = 16;
